import bindAllMethods from '../../../utils/bindAllMethods';
import { getServices } from '../../../infra/startup';
import {
  GrantsHistoryInterfaceType,
  GrantHistoryType,
  GrantsHookReturnType
} from '@clientos/types';
import { IGrantHistoryService } from '../../../services/grants/grantsHistory/IGrantHistoryService';
import { GrantHistoryOptionsType } from '../../../services/grants/grantsHistory/types';

export class GrantsHistoryInterfaceV1 {
  private grantHistoryService: IGrantHistoryService;

  constructor() {
    const services = getServices();
    this.grantHistoryService = services.grantHistoryService;

    bindAllMethods(this);
  }

  getInterface(): GrantsHistoryInterfaceType {
    return {
      refresh: this.refresh,
      checkGrantsHistory: this.checkGrantsHistory,
      useReactCheckGrantsHistory: this.useReactCheckGrantsHistory
    };
  }

  private async refresh(options?: GrantHistoryOptionsType): Promise<void> {
    return this.grantHistoryService.refresh(options);
  }

  private async checkGrantsHistory(
    grants: GrantHistoryType[],
    options?: GrantHistoryOptionsType
  ): Promise<boolean> {
    return this.grantHistoryService.checkGrantsHistory(grants, options);
  }

  private useReactCheckGrantsHistory(
    _React: any,
    grants: GrantHistoryType[],
    options?: GrantHistoryOptionsType
  ): GrantsHookReturnType {
    return this.grantHistoryService.useReactCheckGrantsHistory(
      _React,
      grants,
      options
    );
  }
}
